import { render, staticRenderFns } from "./Pegasus.vue?vue&type=template&id=46fddbf6&"
import script from "./Pegasus.vue?vue&type=script&lang=js&"
export * from "./Pegasus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports